import React, { useMemo, useState } from 'react';
import { Space } from 'antd';
import { Table, Button, Message } from '@alifd/next';
import Swal from 'sweetalert2';
import moment from 'moment';
import client from '@/lib/feathers';
import useSort from '@/lib/hooks/useSort';
import { Box } from '@mui/material';
import UpdateRecordDialog from './components/UpdateRecordDialog';

const { Column } = Table;
const uploads = client.service('uploads');

const tradeTypeLabel = {
  income: '收入',
  expense: '支出',
  transfer: '轉帳',
};

export default function FinanceCommunityList({
  financeCommunity,
  financeCommunityData,
  subjects,
  setIsUpdate,
  nestedSubjects,
}) {
  const [showUpdateRecordDialog, setShowUpdateRecordDialog] = useState(false);
  const [editingRecordValues, setEditingRecordValues] = useState({});

  const dataSource = useMemo(() => {
    const returnData = [];
    if (financeCommunityData.length > 0 && subjects.length > 0) {
      financeCommunityData.forEach((item) => {
        const debitSubject = subjects.find(
          (subject) => subject._id === item.debitSubjectId
        );
        const creditSubject = subjects.find(
          (subject) => subject._id === item.creditSubjectId
        );
        returnData.push({
          ...item,
          key: item._id,
          debitSubjectName: debitSubject.subjectName,
          creditSubjectName: creditSubject.subjectName,
        });
      });
    }
    return returnData;
  }, [financeCommunityData, subjects]);

  const handleRemoveRecord = async (id, attachment) => {
    const result = await Swal.fire({
      title: '確定刪除?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '確定',
      cancelButtonText: '取消',
    });
    if (result.isConfirmed) {
      try {
        await financeCommunity.remove(id);
        if (attachment) {
          uploads.remove(attachment.id);
        }
        setIsUpdate(true);
        Message.success('刪除成功');
      } catch (error) {
        Message.error('刪除失敗');
      }
    }
  };

  const [sortFinanceCommunityData, sort, handleSort] = useSort(dataSource);

  console.log({
    nestedSubjects,
    setIsUpdate,
    editingRecordValues,
    setEditingRecordValues,
    showUpdateRecordDialog,
    setShowUpdateRecordDialog,
    uploads,
  });

  return (
    <Box
      sx={{
        bgcolor: 'white',
        borderRadius: '4px',
        padding: '20px',
      }}
    >
      <Table
        dataSource={sortFinanceCommunityData}
        sort={{ [sort.dataIndex]: sort.order }}
        onSort={(dataIndex, order) => handleSort({ dataIndex, order })}
        fixedHeader
        maxBodyHeight="550px"
      >
        <Column
          width={150}
          title="交易日期"
          sortable
          dataIndex="tradeDate"
          cell={(value) => {
            return moment(value).format('YYYY-MM-DD');
          }}
        />
        <Column
          width={150}
          title="交易類別"
          dataIndex="tradeType"
          sortable
          cell={(val) => tradeTypeLabel[val]}
        />
        <Column
          width={150}
          title="借方科目"
          sortable
          dataIndex="debitSubjectName"
        />
        <Column
          width={150}
          title="貸方科目"
          sortable
          dataIndex="creditSubjectName"
        />
        <Column width={150} title="金額" sortable dataIndex="amount" />
        <Column width={150} title="交易內容" dataIndex="remark" />
        <Column
          width={300}
          title="附件"
          dataIndex="attachment"
          cell={(attachment) => {
            if (attachment) {
              return (
                <a href={attachment.path} download={attachment.name}>
                  {attachment.name}
                </a>
              );
            }
          }}
        />
        <Column
          title="操作"
          lock="right"
          width={200}
          cell={(_value, _index, record) => {
            const createCascadeSubjectsArray = (subjectId) => {
              const returnArray = [];

              nestedSubjects.forEach((parentSubject) => {
                if (parentSubject.children) {
                  if (
                    parentSubject.children.find(
                      (child) => child._id === subjectId
                    )
                  ) {
                    returnArray.push(parentSubject._id);
                  }
                }
              });
              returnArray.push(subjectId);
              return returnArray;
            };

            const defaultValues = {
              ...record,
              tradeDate: moment(record.tradeDate),
              creditSubjectIdArray: createCascadeSubjectsArray(
                record.creditSubjectId
              ),
              debitSubjectIdArray: createCascadeSubjectsArray(
                record.debitSubjectId
              ),
            };
            return (
              <Space style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  onClick={() => {
                    setShowUpdateRecordDialog(true);
                    setEditingRecordValues(defaultValues);
                  }}
                >
                  編輯
                </Button>
                <Button
                  type="primary"
                  warning
                  onClick={() =>
                    handleRemoveRecord(record._id, record.attachment)
                  }
                >
                  刪除
                </Button>
              </Space>
            );
          }}
        />
      </Table>
      <UpdateRecordDialog
        {...{
          nestedSubjects,
          setIsUpdate,
          editingRecordValues,
          setEditingRecordValues,
          showUpdateRecordDialog,
          setShowUpdateRecordDialog,
          uploads,
        }}
      />
    </Box>
  );
}
